module.exports = __webpack_public_path__ + "media/images/logos/rotpunkt-setzen-f642f5e33486f99b54484c42540d1cf3.png";